/**
 * @mixin gameHardMixin
 * @desc 上級編ゲーム共通メソッド
 */
export default {
  methods: {
    /**
     * お題データのランダムな並べ替え
     */
    shuffleQuestionData () {
      for (let i = this.qdata.length - 1; i > 0; i--) {
        let r = Math.floor(Math.random() * (i + 1));
        /* eslint no-unexpected-multiline: 0 */
        [this.qdata[i], this.qdata[r]] = [this.qdata[r], this.qdata[i]]
      }
    },

    /**
     * 残りのカードのIDのリセット
     */
    resetRestDataIndex () {
      this.restDataID = []
      for (let i = 1; i <= this.data.length; i++) {
        this.restDataID.push(i)
      }
    },

    /**
     * タイマー作動中チェック
     */
    timerIsRunnig () {
      return this.questionTimer1 != null
    },

    /**
     * ゲーム終了チェック
     */
    gameIsFinished () {
      return this.restDataID.length === 0
    },

    /**
     * ルーレットスタート
     */
    playGame () {
      // console.log("playGame")

      // タイマーチェック
      if (this.timerIsRunnig()) {
        return
      }

      // 終了チェック
      if (this.gameIsFinished()) {
        // console.log("終わっている")
        this.showFinishAlert()
        return
      }

      // ストップ音がプログラム操作で再生できるようにように最初だけ鳴らす
      if (this.restDataID.length === this.data.length) {
        this.playStopSound()
      }

      // 該当ありのお題を探す
      this.currentQuestionIndex += 1
      while (!this.checkAnswer()) {
        this.currentQuestionIndex += 1
        if (this.currentQuestionIndex >= this.qdata.length) {
          this.currentQuestionIndex = 0
        }
      }

      // 正解ポップアップに表示するli要素を作成
      this.createAnswerItems()

      // 現在のお題のインデックスを保存（グラフ作成用）
      this.$store.dispatch("setQuestionIndex", {
        idx: this.currentQuestionIndex
      })

      // 該当するカードを探してもろもろの配列を更新
      let ac = 0
      for (let i = 0; i < this.currentQuestionAnswers.length; i++) {
        this.deleteUsedData(this.currentQuestionAnswers[i])
        ac += 1
      }
      this.answer_count = ac
      // console.log("残り", this.restDataID)

      // スタート
      this.start_btn_label = "ルーレット中！"
      this.answer_btn_show = false
      this.isActive = false
      this.startTimer()
      this.playRouletteSound()
    },

    /**
     * ルーレットを再スタート
     */
    nextGame () {
      this.answer_view_show = false
      this.playGame()
    },

    /**
     * リセットボタンイベント
     * 確認ポップアップを表示する
     */
    resetGame () {
      if (this.timerIsRunnig()) {
        return
      }
      // console.log("resetGame")
      this.playPopupSound()
      this.animation = "flip"
      this.reset_alert_show = true
    },

    /**
     * ルーレットをリセット
     * 確認ポップアップの「OK」ボタンのイベント
     */
    resetGameB () {
      this.item_title1_src = "お題"
      this.item_title2_src = ""
      this.item_title3_src = ""
      this.item_unit1 = ""
      this.item_unit2 = ""
      this.item_units = ""
      this.start_btn_label = "スタート"
      this.questionTimer1 = null
      this.currentQuestionIndex = 0
      this.answerItems.length = 0
      this.shuffleQuestionData()
      this.resetRestDataIndex()
      this.reset_alert_show = false
      this.answer_btn_show = false
      this.isActive = true
      this.answerItemsS.length = 0
      this.answerItems.length = 0
      this.selectedDataID.length = 0
    },

    /**
     * ゲーム終了ポップアップを表示
     */
    showFinishAlert () {
      this.playPopupSound()
      this.animation = "slideDown"
      this.finish_alert_show = true
    },

    /**
     * 「正解を表示」ボタンイベント
     * 正解ポップアップを表示
     */
    showAnswer () {
      this.playPopupSound()
      this.animation = "rotate"
      this.answer_view_show = true
    },

    /**
     * 「グラフをみてみよう」ボタンイベント
     * 棒グラフポップアップを表示
     */
    showChart () {
      this.playPopupSound()
      this.animation = "slideUp"
      this.chart_view_show = true
    },

    /**
     * お題のルーレット表示を開始
     * <ul>
     * <li>0.1秒単位でchangメソッドを呼ぶタイマーをスタートする</li>
     * <li>4秒後にストップイベントを呼ぶタイマーをセットする</li>
     * </ul>
     */
    startTimer () {
      this.questionTimer1 = setInterval(() => {
        this.changeQuestion()
      }, 100)
      setTimeout(this.stopQuestionTimer1, this.stopInterval)
    },

    /**
     * お題データをランダムで取得して表示をラベルを更新
     */
    changeQuestion () {
      const randnum = Math.floor(Math.random() * this.qdata.length)
      const currentQ = this.qdata[randnum]
      this.item_title1_src = currentQ.title1
      this.item_title2_src = currentQ.title2[0]
      this.item_title3_src = currentQ.title2[2]
      this.item_unit1 = currentQ.title2[1]
      this.item_unit2 = currentQ.title2[3]
      this.item_units = currentQ.units
    },

    /**
     * <ul>
     * <li>タイマーを破棄</li>
     * <li>正解のテキストを表示</li>
     * <li>サウンドを停止</li>
     * <li>ボタンのラベルを更新</li>
     * <ul>
     */
    stopQuestionTimer1 () {
      clearInterval(this.questionTimer1)
      this.questionTimer1 = null
      const currentQ = this.qdata[this.currentQuestionIndex]
      this.item_title1_src = currentQ.title1
      this.item_title2_src = currentQ.title2[0]
      this.item_title3_src = currentQ.title2[2]
      this.item_unit1 = currentQ.title2[1]
      this.item_unit2 = currentQ.title2[3]
      this.item_units = currentQ.units
      this.updateVCtrlBtns()
      this.stopRouletteSound()
      this.playStopSound()
    },

    /**
     * <ul>
     * <li>ボタンのラベルを更新</li>
     * <li>「正解を表示」ボタンを表示</li>
     * <li>ボタンの非アクティブを解除</li>
     * <ul>
     */
    updateVCtrlBtns () {
      if (this.timerIsRunnig()) {
        return
      }
      if (this.gameIsFinished()) {
        this.start_btn_label = "ゲーム終了！"
        return
      }
      this.start_btn_label = "Next！"
      this.answer_btn_show = true
      this.isActive = true
    },

    /**
     * 残りのカードの中にお題に該当するカードがあるかをチェックする
     * @return {Boolean} true/false あり/なし
     */
    checkAnswer () {
      const answers = []
      const currentQ = this.qdata[this.currentQuestionIndex]
      for (let i = 0; i < this.restDataID.length; i++) {
        let found = this.getDataById(this.restDataID[i])
        let ckData = found[currentQ.item]
        if (currentQ.min <= ckData && ckData < currentQ.max) {
          answers.push(found.id)
        }
      }
      if (answers.length === 0) {
        // console.log("該当なし")
        this.currentQuestionAnswers.length = 0
        return false
      } else {
        this.currentQuestionAnswers = answers
        // console.log("該当", this.currentQuestionAnswers)
        return true
      }
    },

    /**
     * カードデータをIDで取得
     */
    getDataById (targetID) {
      return this.data.find((data) => {
        return data.id === targetID
      })
    },

    /**
     * targetIDを
     * <ul>
     * <li>selectedDataID（表示済みカードのIDの配列）に追加</li>
     * <li>restDataID（残りのカードのIDの配列）から削除</li>
     * </ul>
     */
    deleteUsedData (targetID) {
      this.selectedDataID.push(targetID)
      this.restDataID = this.restDataID.filter(n => n !== targetID)
    },

    /**
     * 正解の<li>要素を生成
     */
    createAnswerItems () {
      const currentQ = this.qdata[this.currentQuestionIndex]
      const selectedAnswers = []
      for (let sID of this.selectedDataID) {
        let found = this.getDataById(sID)
        let ckData = found[currentQ.item]
        if (currentQ.min <= ckData && ckData < currentQ.max) {
          selectedAnswers.push(found.id)
        }
      }

      const restAnswers = []
      for (let rID of this.restDataID) {
        let found = this.getDataById(rID)
        let ckData = found[currentQ.item]
        if (currentQ.min <= ckData && ckData < currentQ.max) {
          restAnswers.push(found.id)
        }
      }

      // console.log("in selected", selectedAnswers)
      // console.log("in rest", restAnswers)

      this.answerItemsS.length = 0
      for (let i = 0; i < selectedAnswers.length; i++) {
        let answerID = selectedAnswers[i]
        let answerData = this.getDataById(answerID)
        this.answerItemsS.push({ message: answerData.name })
      }

      this.answerItems.length = 0
      for (let i = 0; i < restAnswers.length; i++) {
        let answerID = restAnswers[i]
        let answerData = this.getDataById(answerID)
        this.answerItems.push({ message: answerData.name })
      }

      // 正解の数に合わせて正解ポップアップの高さを調整
      this.answer_view_height = 46 * (this.answerItems.length + this.answerItemsS.length) + 160
    }
  }
}
